import { motion } from "framer-motion";
import appHome from "../../../Assets/home/appHomepage.jpeg";

const features = [
  {
    title: "Real-Time Smart Dispatch",
    desc: "Nearest verified vendor auto-assigned instantly using live location streams."
  },
  {
    title: "Nationwide On-Ground Network",
    desc: "1500+ cranes, recovery units & verified partners nationwide."
  },
  {
    title: "Rapid Emergency Activation",
    desc: "Sub-30 minute activation model with continuous status updates."
  },
  {
    title: "Unified Assistance Ecosystem",
    desc: "Towing, legal coordination, inspection & documentation in one system."
  }
];

export default function WhyClaimProInteractive() {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-[#050816] via-[#0A0F2C] to-[#111827] text-white overflow-hidden">

      {/* Ambient Background Glow */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute w-[600px] h-[600px] bg-[#21A6E9] blur-[200px] left-[10%] top-[10%]" />
        <div className="absolute w-[500px] h-[500px] bg-indigo-500 blur-[180px] right-[5%] bottom-[10%]" />
      </div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 items-center">

        {/* LEFT — 3D PHONE */}
        <motion.div
          initial={{
            x: -200,
            opacity: 0,
            rotateY: 20,
            rotateZ: -6,
            scale: 0.95
          }}
          whileInView={{
            x: 0,
            opacity: 1,
            rotateY: 0,
            rotateZ: 0,
            scale: 1
          }}
          transition={{
            duration: 1.1,
            ease: [0.22, 1, 0.36, 1]
          }}
          viewport={{ once: true, amount: 0.4 }}
          style={{ perspective: 1200 }}
          className="flex justify-center"
        >
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="relative"
          >
            {/* Glow Behind Phone */}
            <div className="absolute -inset-16 bg-[#21A6E9] opacity-25 blur-[140px] rounded-full" />

            {/* Device Frame */}
            <div className="relative bg-black rounded-[42px] p-3 shadow-[0_40px_100px_rgba(0,0,0,0.6)] border border-slate-700">

              {/* Notch */}
              <div className="absolute top-2 left-1/2 -translate-x-1/2 w-28 h-6 bg-black rounded-b-2xl z-20" />

              {/* Screen */}
              <div className="rounded-[32px] overflow-hidden bg-black">
                <img
                  src={appHome}
                  alt="ClaimPro App"
                  className="w-[300px] sm:w-[330px] md:w-[360px] object-cover"
                />
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* RIGHT — CONTENT */}
        <div className="space-y-10">

          {/* Emotional Heading */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight">
              Emergencies Don’t Wait.
              <br />
              <span className="bg-gradient-to-r from-[#21A6E9] to-indigo-500 bg-clip-text text-transparent">
                Neither Do We.
              </span>
            </h2>

            <p className="mt-6 text-slate-400 max-w-lg">
              When you're stranded on a highway at midnight,
              it’s not just a vehicle issue — it’s stress,
              uncertainty and vulnerability.
              ClaimPro responds with structured coordination,
              real-time updates and human-backed support.
            </p>
          </motion.div>

          {/* Feature Cards */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ x: 80, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  delay: 0.25 + index * 0.12,
                  duration: 0.6
                }}
                viewport={{ once: true }}
                className="group relative bg-[#0F172A] border border-[#1E293B] rounded-2xl p-6 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_25px_60px_rgba(33,166,233,0.15)]"
              >
                {/* Hover Glow Layer */}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-indigo-500/20 via-[#21A6E9]/20 to-indigo-500/20 blur-xl" />

                {/* Subtle Border Highlight */}
                <div className="absolute inset-0 rounded-2xl ring-1 ring-transparent group-hover:ring-[#21A6E9]/40 transition duration-500" />

                <div className="relative z-10">
                  <h4 className="text-xl font-semibold text-white group-hover:text-[#21A6E9] transition-colors duration-300">
                    {feature.title}
                  </h4>
                  <p className="text-slate-400 mt-2">
                    {feature.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
}